// extracted by mini-css-extract-plugin
module.exports =  {"mod-text":"campaignStartModal__mod-text"};